import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, toConsumableArray as _toConsumableArray, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { marginBottomLevels, getMarginBottomClass } from '@piggybank/core';
import { Provider } from './context.js';
import isEqual from 'react-fast-compare';
import kebabCase from 'lodash/fp/kebabCase';
import styles from './field.css.js';

var FieldProvider = /*#__PURE__*/function (_Component) {
  _inherits(FieldProvider, _Component);

  function FieldProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FieldProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FieldProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      registeredData: []
    });

    _defineProperty(_assertThisInitialized(_this), "register", function (datum) {
      if (!_this.state.registeredData.includes(datum)) {
        _this.setState(function (state) {
          return {
            registeredData: [].concat(_toConsumableArray(state.registeredData), [datum])
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getDescribers", function () {
      var describers = _this.state.registeredData.filter(function (_ref) {
        var describerId = _ref.describerId;
        return !!describerId;
      }).filter( // Only include FieldFeedback in the describers list when the Field is invalid with an error
      function (_ref2) {
        var component = _ref2.component;
        return _this.props.invalid && _this.props.error || component !== 'FieldFeedback';
      }).map(function (_ref3) {
        var describerId = _ref3.describerId;
        return describerId;
      }).join(' ');

      return describers;
    });

    return _this;
  }

  _createClass(FieldProvider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState !== this.state || !isEqual(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          error = _this$props.error,
          touched = _this$props.touched,
          invalid = _this$props.invalid,
          required = _this$props.required,
          extraDescriber = _this$props.extraDescriber,
          _this$props$component = _this$props.component,
          Component = _this$props$component === void 0 ? 'div' : _this$props$component,
          _this$props$marginBot = _this$props.marginBottom,
          marginBottom = _this$props$marginBot === void 0 ? 5 : _this$props$marginBot,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["name", "value", "onChange", "onBlur", "error", "touched", "invalid", "required", "extraDescriber", "component", "marginBottom", "children"]);

      return React.createElement(Component, _extends({
        className: cn(styles['Field'], getMarginBottomClass(marginBottom)),
        id: kebabCase("field-".concat(name))
      }, rest), React.createElement(Provider, {
        value: {
          name: name,
          value: value,
          onChange: onChange,
          onBlur: onBlur,
          error: error,
          touched: touched,
          invalid: invalid,
          required: required,
          describers: cn(this.getDescribers(), extraDescriber) || null,
          register: this.register
        }
      }, children));
    }
  }]);

  return FieldProvider;
}(Component);

FieldProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  extraDescriber: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  touched: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  component: PropTypes.oneOf(['div', 'fieldset']),
  children: PropTypes.node,
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default FieldProvider;